import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDesistementVenteListTable, IAuthReduxProps, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faExternalLinkAlt, faFileInvoice, faGripLines, faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import PDFLink from '../pdf/PDFLink';
import Association from '../consultation/Association';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'

const DesistementVenteListeTable = ({ 
  ventesData,
  selectVente,
  getDataFromPromise,
  auth
 }: IDesistementVenteListTable) => {
  const history = useHistory();
  const alert = useAlert();
  const [modalAss, setModalAss] = useState(false);
  const [modalAssVente, setModalAssVente] = useState<any>(null);
  const [associationPartInfo, setAssociationPartInfo] = useState<any>('');
  useEffect(() => console.log("ventesData", ventesData), [ventesData])
  const modalClosedHandleAss = () => {
    setAssociationPartInfo('')
  };

  const handleToggleAss = () => setModalAss(!modalAss);

  const columns = useMemo(
    () => [
      {
        Header: "Choisir",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                {((row.original.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || !!row.original.en_cours_signature) && !auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER)) ? <i style={{fontSize: "small"}}>Signé</i> : row.original.TYPE_VENTE === "ASSOCIATION" ? (row.original.associations?.length ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                    onClick={() => {
                      if(row.original.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || !!row.original.en_cours_signature)
                        alert.error("Attention! La vente est signé au notaire")
                      setModalAssVente(row.original)
                      setModalAss(true)
                    }}
                    title="Plus d'informations sur l'association">
                    <FontAwesomeIcon icon={faGripLines} />
                  </button> : null) : <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={(e) => {
                    // if(row.original.TYPE_VENTE === "ASSOCIATION")
                    //   alert.info("EN CONSTRUCTION")
                    // else
                    if(row.original.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || !!row.original.en_cours_signature)
                      alert.error("Attention! La vente est signé au notaire")
                    if(!row.original.hasPermission)
                      alert.info("Vous n'êtes pas autorisé à accéder à cette vente.")
                    else
                      selectVente(row.original.id, false)
                  }}
                  // onClick={(e) => history.push(`/consultation/${row.original.id}`)}
                  title="Choisir">
                  <FontAwesomeIcon icon={faCheck} />
                </button>}
            </Container>
        ),
        disableSortBy: true,
      },
      {
        Header: "ID vente",
        accessor: "id",
        Cell: ({ value }) => {
          return (<a href={value !== null && value !== undefined ? (`/consultation/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/consultation/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/consultation/${value}` })
            }
            else
              alert.error(E_ERROR.NO_CLIENT_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        },
        hidden: true
      },
      {
        Header: "Projet",
        accessor: "PROJET",
        hidden: true
      },
      {
        Header: "Désignation",
        accessor: "DESIGNATION",
        hidden: true
      },
      {
        Header: "N° Dossier",
        accessor: "NUM_DOSS",
      },
      {
        Header: "Date Vente",
        accessor: "DATE_RESERV",
        customExportDisplay: `$.DATE_RESERV ? new Date($.DATE_RESERV) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Type Vente",
        accessor: "TYPE_VENTE",
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: "N°",
        accessor: "N",
        filter: 'equals',
      },
      // {
      //   Header: "Type",
      //   accessor: "TYPE_2",
      //   customExportDisplay: `$.TYPE || "-"`,
      //   Filter: (e) => SelectColumnFilter({...e, capitalizeFirst: true}),
      //   filter: 'equals',
      //   Cell: ({ row }) => row.original.TYPE || "-"
      // },
      {
        Header: "Type",
        accessor: "TYPE",
        customExportDisplay: `$.TYPE || "-"`,
        filter: (rows, id, e) => rows.filter(t => (t.original[id]?.toLowerCase().includes("app") ? "Appartement" : t.original[id]?.toLowerCase().includes("mag") ? "Magasin" : (t.original[id] || "")).toLowerCase().includes(e?.toLowerCase() || "")),
        Cell: ({ row }) => row.original.TYPE?.toLowerCase().includes("app") ? "Appartement" : row.original.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (row.original.TYPE || "-")
      },
      {
        Header: "Tranche",
        accessor: "TRANCHE",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Immeuble",
        accessor: "IMMEUBLE",
        Cell: ({ value }) => !value && value !== "0" ? "-" : value,
        hidden: true
      },
      {
        Header: "Étage",
        accessor: "ETAGE",
        // Filter: SelectColumnFilter,
        // filter: 'equals',
        Cell: ({ value }) => !value && value !== "0" ? "-" : value,
        hidden: true
      },
      {
        Header: "Superficie",
        accessor: "SUPERFICIE",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ value, row }) => row.original.TYPE_2?.toLowerCase() === "appartement" ? "-" : (value + "m²")
      },
      {
        Header: "Prix Net du M²",
        accessor: "PRIX_M",
        hidden: true,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Prix Net",
        accessor: "PRIX_NET",
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") || (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (<div><div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.id === "PRIX_M")?.isVisible && (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (" (" + ((row.original.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")) + "/m²)") : "")}</div></div>) : "-"
      },
      {
        Header: "Aperçu",
        className: "text-center",
        disableSortBy: true,
        Cell: ({ row }) => (
          <PDFLink documentType={"vente"}
            // data={row.original}
            {...(getDataFromPromise ? {func: async () => getVenteByIdPromise(row.original.id || -1)} : {data: row.original})}
            download={false}
            buttonText=""
            iconSize="inherit"
            // customClassNames="btn btn-info"
            customButtonIcon={faFileInvoice}
            allowPrintPreview={true}
            htmlTitle="Voir la fiche de Vente"
            customClassNames="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
            style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
        )
      },
    ],
    []
  );

  return (<>
    <div className="fadeAnimation">
      <TableContainer columns={columns} data={ventesData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
    </div>
    

    <Modal isOpen={modalAss} toggle={handleToggleAss} onClosed={modalClosedHandleAss} className="modal-dialog-large" style={{minWidth: "900px"}} modalClassName="xOverflowModal">
      <ModalHeader toggle={handleToggleAss}><FontAwesomeIcon icon={faGripLines} />&nbsp;&nbsp;Détails de l'association</ModalHeader>
      <ModalBody>
        <Association associations={modalAssVente?.associations} etages={modalAssVente?.bien?.ETAGE_ASS} associationPartInfo={associationPartInfo} setAssociationPartInfo={setAssociationPartInfo} chooseAssociation={e => selectVente(e, true)} isModal />
      </ModalBody>
    </Modal>
  </>);
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(DesistementVenteListeTable);
